import { useContext } from 'react';

import { storeContext } from '../mobx/store-provider';

export default function useStores() {
  const { store } = useContext(storeContext);

  return store;
}
export function useResetStore() {
  const { reset } = useContext(storeContext);

  return reset;
}
